export { CollectFeedbackV2 } from './CollectFeedbackV2';
